import $ from 'jquery';
import BaseView from '../../core/baseView';
import * as lightbox from '../../../home24/helpers/lightbox';

export default BaseView.extend({
  $form: null,

  initialize: function(options) {
    this.$form = options.$form;

    lightbox
      .setConfig({
        $dialog: $('.js-fttc2-image-notification'),
        className: 'fttc2-image-notification',
        onOpen: this.onOpen.bind(this)
      })
      .open();
  },

  onOpen: function() {
    $('.js-fttc2-image-notification-proceed').on(
      'click',
      this.submitHandler.bind(this)
    );
  },

  submitHandler: function() {
    this.$form[0].submit();
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/Step2ImageNotificationView.js
 **/